module.exports = __webpack_public_path__ + "media/images/light/logo/favicon-7e00e47d2370b7ab9f073657deacb9d5.png";